import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { useFormikContext } from "formik";
import { selectIsCms } from "../../../../../../redux/slices/configSlice";
import { selectAllRegistration } from "../../../../../../redux/slices/registrationSlice";
import { selectAllP2pSettings } from "../../../../../../redux/slices/p2pSettingsSlice";
import { selectCmsControlByType } from "../../../../../../redux/slices/cmsSettingsSlice";
import { setAppTeamModalOpen } from "../../../../../../redux/slices/appSettingsSlice";
import { selectAllCategories } from "../../../../../../redux/slices/categoriesSlice";
import { selectAllClassifications } from "../../../../../../redux/slices/classificationsSlice";
import JoinTeamFooter from "./JoinTeamFooter";

const ConnectedJoinTeamFooter = () => {
    const { values, setFieldValue } = useFormikContext();
    const { Category, Team } = values;

    const hasSelectedTeam = !!Team;

    const { ENUMS } = constants;
    const {
        CMS_Control: {
            P2P_REGISTRATION_CLASSIFICATIONS,
            P2P_REGISTRATION_CONTENT,
        },
    } = ENUMS;
    const isCms = useSelector(selectIsCms);
    const registration = useSelector(selectAllRegistration);
    const {
        classification: { Classification },
        currentRegistration,
    } = registration;
    const { enableTeamCreation } = useSelector(selectAllP2pSettings);
    const classifications = useSelector(selectAllClassifications);
    const categories = useSelector(selectAllCategories);
    const classification =
        Object.keys(registration.classification).length > 0 &&
        typeof Classification[0] === "string"
            ? classifications.find(({ id }) => `${id}` === Classification[0])
            : {};

    const { displayTeamSpotsLeft = false, teamSpotsLeft } = classification;

    const control = useSelector((state) =>
        selectCmsControlByType(P2P_REGISTRATION_CLASSIFICATIONS, state),
    );

    const classificationControl = typeof control === "object" ? control : {};

    const {
        options: { maxNewTeamsReachedLabel = "No longer accepting new teams." },
    } = classificationControl;

    const registrationContentControl = useSelector((state) =>
        selectCmsControlByType(P2P_REGISTRATION_CONTENT, state),
    );

    const {
        options: {
            joinTeamModal: {
                backLinkLabel = "Back",
                createTeamButtonLabel = "Start A New Team",
            },
        },
    } = registrationContentControl;

    const formattedTeamLimitLabel = maxNewTeamsReachedLabel;

    const displayTeamLimitReached =
        displayTeamSpotsLeft &&
        typeof teamSpotsLeft === "number" &&
        teamSpotsLeft === 0;

    // Determine if the category allows Teams to be created
    const category = categories.find(
        (selectedCategory) => `${selectedCategory.id}` === Category[0],
    );
    const { attachTeamCaptains } = category;

    const enableCreateTeam =
        enableTeamCreation &&
        attachTeamCaptains &&
        !displayTeamLimitReached &&
        currentRegistration === 0;

    const joinTeamFooterProps = {
        isCms,
        displayTeamLimitReached,
        enableCreateTeam,
        formattedTeamLimitLabel,
        hasSelectedTeam,
        backLinkLabel,
        createTeamButtonLabel,
        setAppTeamModalOpen,
        setFieldValue,
    };

    return <JoinTeamFooter {...joinTeamFooterProps} />;
};

export default ConnectedJoinTeamFooter;
